import { connect } from 'react-redux';
import { getCompanyFieldReplacements } from 'store/modules/company';
import { findId, getFacilityFieldReplacements } from 'store/modules/facilities';
import EditableRichText from '../components/EditableRichText';

const mapStateToProps = (state) => {
  const companyFieldReplacements = getCompanyFieldReplacements(state);
  const facilityId = findId({}, state);

  const facilityFieldReplacements = getFacilityFieldReplacements(state, facilityId);

  return {
    fieldReplacements: {
      ...companyFieldReplacements,
      ...facilityFieldReplacements,
    },
    files: [],
  };
};

const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditableRichText);
